import React, { Component, Fragment } from 'react';
import { Link, Route } from 'react-router-dom';
import DosenTetap from './tetap/DosenTetap';
import DetailDosen from './tetap/DetailDosen';

class DataDosen extends Component {
    componentDidMount = () => {
        if (document.getElementById("dosenNav")) {
            document.getElementById("dosenNav").classList.add("active");
        }
        if (document.getElementById("dosenOpen")) {
            document.getElementById("dosenOpen").classList.add("show");
        }
    }

    render() {
        var currentPage = window.location.pathname.split("/").slice(-1)[0].replace(/^\/|\/$/g, '');
        if (currentPage == "data-dosen") {
            currentPage = "Data Dosen";
        } else {
            currentPage = "Detail"
        }
        localStorage.setItem('grub_id', this.props.grub_id);
        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{
                                fontSize: '15px', fontWeight: 'bold', color: '#999999',
                                textTransform: 'capitalize'
                            }}>
                                Dosen&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;<Link to="/data-dosen">Data Dosen</Link>&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;{currentPage}
                            </p>
                        </div>
                    </div>
                </div>

                {/* routes data dosen  */}
                <Route exact path="/data-dosen" component={DosenTetap} />
                <Route path="/data-dosen/detail/:dosenid" component={DetailDosen} />
                {/* end routes data dosen  */}
            </Fragment>
        );
    }
}

export default DataDosen;